import React, { memo, PropsWithChildren, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { IconAccordion2, ThickMarkIcon } from '../../assests/icons/Icons'
// import { accodianMsgT } from '../../ReduxTool/Slice/Partner/EPC';
import { IconArrow } from '../../assests/icons/DrawerIcons';

import { store } from '../../ReduxTool/store/store';
import { useAppSelector } from '../../ReduxTool/store/hooks';
import CustomTooltip from '../../Components/ReactTooltip/CustomTooltip';
import { Button } from '../../Components/Button';

export type MessageType = "success" | "error" | "warning" | "info";
export type accodianMsgT = { type: MessageType, message: string, isInfoAutoHide?: boolean, parentPaddingTop?: string }


interface IAccordion2 {
  headName: string;
  attribute?: string;
  open?: boolean;
  children: JSX.Element
  onToggle: (headName: any) => void;
  subHeader?: JSX.Element | string;
  accordianName: string;
  IconContent?: JSX.Element;
  headerClassName?: string;
  accType?: "primary" | "secondary" | "tertiary";
  accBodyMaxHeight?: string;
  maxHeight?: string;
  backspace?: (e: any) => void;
  onPrimaryBtnClick?: <T>(e: any, accName?: T) => void;
  onPrimaryBtnClick2?: <T>(e: any, accName?: T) => void;
  onOutlineBtnClick2?: <T>(e: any, accName?: T) => void;
  onOutlineClick?: (e: any, accName?: string) => void;
  outlinBtnProp?: React.ReactNode;
  primaryBtn2LeftIcon?: JSX.Element;
  infoMessage?: accodianMsgT,
  isProgressbar?: boolean
  outBtnName?: string;
  primaryBtnName?: string
  primaryBtn2Name?: string
  outlineBtn2Name?: string
  moreResOptionsChild?: JSX.Element
  isHeaderFixed?: boolean
  isInfoShow?: boolean
  isLoading?: boolean
  loadingTitle?: string,
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  disabled?: boolean,
  accLastIdx?: string
  status?: StepStatus
  stepHeight?: string
  stepMinHeight?: string
  stepMaxHeight?: string
  stepNumber?: number;
  onDisableClick?: () => void
  flexDirectionFootterPropsBtn?: React.CSSProperties["flexDirection"];
}
type StepStatus = 'completed' | 'current' | 'upcoming' | 'skipped';



interface Step {
  number: number;
  label: string;
  content?: React.ReactNode;
}

const steps: Step[] = [
  { number: 1, label: 'Basic details', content: <p>This is basic details content.</p> },
  { number: 2, label: 'Company details', content: <p>This is company details content.</p> },
  { number: 3, label: 'Subscription plan', content: <p>This is a lot of content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> },
  { number: 4, label: 'Payment details', content: <p>This is payment details content.</p> },
];

const NewStepperAccordian: React.FC<PropsWithChildren<IAccordion2>> = ({ headName, attribute, open,stepNumber, children, onToggle, subHeader, accordianName,
  IconContent, headerClassName, accType, accBodyMaxHeight, maxHeight, backspace, onPrimaryBtnClick, onOutlineClick, outlinBtnProp,primaryBtn2LeftIcon,flexDirectionFootterPropsBtn,onPrimaryBtnClick2,onOutlineBtnClick2, primaryBtn2Name,outlineBtn2Name, infoMessage, isProgressbar,
  outBtnName = "More", primaryBtnName = "Save", moreResOptionsChild, isHeaderFixed, isInfoShow, isLoading, loadingTitle,onDisableClick, onMouseEnter, onMouseLeave, disabled, accLastIdx, status, stepHeight, stepMinHeight, stepMaxHeight }) => {
  const { roofAnalysis: { selected_project } } = useAppSelector(state => state.consumerReducers)
  const installer_project_mapping = selected_project?.installer_project_mapping;
  const { is3DMap } = useAppSelector(state => state.mapref);
  const [isInfo, setIsInfo] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [computedMaxPx, setComputedMaxPx] = useState<number | null>(null);
  // console.log("Iscomplete state ---->> ", selected_project?.isepccomplete)

  const [activeStep, setActiveStep] = useState<number | null>(null);
  const [heights, setHeights] = useState<number[]>([]);

  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const toggleStep = (stepNumber: number) => {
    setActiveStep((prev) => (prev === stepNumber ? null : stepNumber));
  };

  useEffect(() => {
    setIsInfo(infoMessage ? true : false);
  }, [infoMessage]);


  const borderColor = status === 'completed' || status === 'current' ? 'border-custom-primary-default' : status === "skipped" ? "border-[#889fa4]" : 'border-gray-200';
  const textColor = status === 'upcoming' ? 'text-slate-400' : 'text-slate-900';
  const contentHeight = open ? accBodyMaxHeight ?? "30vh" : "10"

  // Calculate available height from viewport to this container top, so percentage heights are responsive
  useLayoutEffect(() => {
    const updateAvailable = () => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const viewportH = window.innerHeight;
      // Leave some breathing space below (footer/margins). Adjust as needed.
      const paddingBottom = 40;
      const available = Math.max(0, viewportH - rect.top - paddingBottom);
      setComputedMaxPx(available);
    };
    if (open) {
      updateAvailable();
      window.addEventListener('resize', updateAvailable);
      return () => window.removeEventListener('resize', updateAvailable);
    }
  }, [open]);

  const isPercent = typeof stepHeight === 'string' && stepHeight.trim().endsWith('%');
  const percentValue = isPercent ? Math.min(100, Math.max(0, parseFloat(stepHeight as string))) : null;
  const renderIcon = () => {
    if (status === 'completed') {
      return (
        <ThickMarkIcon className={`size-3 fill-white`} />
        // <>{stepNumber}</>
      );
    }

    if (status === 'upcoming') {
     return (<span className='text-14-roboto'>{stepNumber}</span>)
    }
   
      return (
        <>{stepNumber}</>
      );
    
    return (
      <span className={`size-2 rounded-full ${status === 'current' ? 'bg-custom-primary-default' : status === "skipped" ? "bg-[#889fa4]" : 'bg-gray-300'
          }`}
      />
    );
  };
  const handleWrapperClick = () => {
      if (disabled  && onDisableClick) {
        onDisableClick();
      }
    };
  return (
    <>
      <div className={`flex flex-col space-y-4`} onClick={handleWrapperClick} >
        <div className={`flex items-stretch gap-x-2 mb-1`} style={{ minHeight: "45px" }} >
          {/* Step Indicator + Vertical Line */}
          <div className={`flex flex-col items-center relative pt-0.5`}>
            <div  className={`size-7 border-2 ${borderColor} text-[14px] flex items-center justify-center bg-custom-primary-default  text-white  ${status === "upcoming" && "bg-gray-200 text-black"} rounded-full`} >
              {renderIcon()}
            </div>
            {!accLastIdx && (
              <div className={`w-0.5 flex-1 px mt-1 ${status === 'completed' || status === "current" ? 'bg-custom-primary-default' : status === 'skipped' ? 'bg-[#889fa4]' : 'bg-gray-300'}`} />
            )}
          </div>

          {/* Step Content */}
          <div className="w-full max-w-[22rem]">
           <div className="flex justify-between items-start w-[22rem]">
            <button  disabled={disabled} onClick={(e) => {e.stopPropagation(); onToggle(headName)}} className={`text-left focus:outline-none flex-1 ${disabled ? 'pointer-events-none ' : ''}`} >
              <div className="flex flex-col">
                <div className="flex items-center gap-2">
                   {/* <h3 className={`text-sm font-semibold m-0 p-0 ${status === 'upcoming' ? 'text-slate-900' : 'text-slate-900'}`}>   {headName} </h3> */}
                   <h3 className={`heading-14-roboto-normal`}>   {headName} </h3>
                  {IconContent && open && IconContent}
                </div>
                {subHeader && (
                  <p className="text-12-roboto">   {subHeader} </p>
                )}
              </div>
            </button>

            {/* In Progress Badge */}
            {/* {status === 'current' && !disabled && ( */}
            {status === 'current' && installer_project_mapping?.handover_and_customer_sign_off?.status !== 'Completed' &&  (
              <span className="text-[10px] font-medium px-2 py-0.5 rounded-full border border-orange-300 bg-orange-50 text-orange-400">  In progress  </span>
            )}
          </div>

            {/* Accordion Body */}

            {/* Responsive body height: supports percentages (like 100%) via measured viewport space, else falls back to clamp */}
            <div ref={containerRef} className=' transition-all custom-scrollbar-css scrollbar-hide duration-700 delay-100 ease-in-out' style={{
              maxHeight: open ? (isPercent && computedMaxPx !== null ? `${(computedMaxPx * (percentValue as number)) / 100}px` : `clamp(${stepMinHeight ?? '30vh'}, ${stepHeight ?? '69vh'}, ${stepMaxHeight ?? 'calc(70vh)'})`) : '0px',
              opacity: open ? 1 : 0, display: open ? 'block' : 'none', overflowY: 'auto' }}>
              <div className={`py-2 px-1 ${isInfo && "p-4"}`}>
                {isInfoShow && <CustomTooltip isProgressbar={isProgressbar} position={"sticky"} infoAutoHide={infoMessage?.isInfoAutoHide} type={infoMessage?.type} isVisible={isInfo} setIsVisible={setIsInfo} informationContent={infoMessage?.message!} />}
                {children}
              </div>
              {/*footer from state */}
              {(onPrimaryBtnClick || onOutlineClick) && <div className="flex justify-end gap-2 sticky bottom-0 pt-2 bg-white">
                {/* Secondry/outline btn */}
                {onOutlineClick && <Button className="primary-outline-btn md-btn" name={outBtnName} onClick={(e:any) => onOutlineClick(e, headName)} isLoading={false} disabled={isLoading}  />}
                {/* {onPrimaryBtnClick !== undefined && !(selected_project?.isepccomplete) && <Button disabled={selected_project?.isepccomplete || is3DMap} isLoading={isLoading} loadingTitle={loadingTitle} className="primary-btn md-btn" name={primaryBtnName} onClick={(e) => onPrimaryBtnClick(e, headName)} />} */}
                {/* {onPrimaryBtnClick2 !== undefined && selected_project?.iscompleted && <Button disabled={is3DMap} isLoading={isLoading} loadingTitle={loadingTitle} className="primary-btn md-btn" name={primaryBtn2Name} onClick={(e:any) => onPrimaryBtnClick2(e, headName)} />} */}
                {onPrimaryBtnClick !== undefined && !(selected_project?.iscompleted) && <Button disabled={selected_project?.isepccomplete || is3DMap} isLoading={isLoading} loadingTitle={loadingTitle} className="primary-btn md-btn" name={primaryBtnName} onClick={(e:any) => onPrimaryBtnClick(e, headName)} />}
              </div>}
                {/*footer from props */}
               {( outlinBtnProp || onPrimaryBtnClick2) && <div className="flex justify-end gap-2 sticky bottom-0 py-2 bg-white" style={{flexDirection:flexDirectionFootterPropsBtn}}>
                {/* Secondry/outline btn */}
                {outlinBtnProp && outlinBtnProp }
                {/* {onPrimaryBtnClick !== undefined && !(selected_project?.isepccomplete) && <Button disabled={selected_project?.isepccomplete || is3DMap} isLoading={isLoading} loadingTitle={loadingTitle} className="primary-btn md-btn" name={primaryBtnName} onClick={(e) => onPrimaryBtnClick(e, headName)} />} */}
                {onPrimaryBtnClick2 !== undefined && selected_project?.iscompleted && <Button LeftIcon={primaryBtn2LeftIcon} disabled={is3DMap} isLoading={isLoading} loadingTitle={loadingTitle} className="primary-btn md-btn " name={primaryBtn2Name} onClick={(e:any) => onPrimaryBtnClick2(e, headName)} />}
               </div>}
            </div>
          </div>
        </div>
      </div>

    </>

  )
}
export default memo(NewStepperAccordian)